export const iconFontAwesomeHumanitarianPersonCircleXmark = (
	<i className="fa-solid fa-person-circle-xmark"></i>
);
